// extracted by mini-css-extract-plugin
export default {"wrapper":"Shield_wrapper__-0gpc","wrapperLeft":"Shield_wrapperLeft__y6De-","wrapperRight":"Shield_wrapperRight__9qIo1","text":"Shield_text__a20WJ"};